function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useRef } from 'react';
import { HeaderNavigationStyles } from './HeaderNavigationStyles';
export default function SimpleMenu(_ref) {
  var appProps = _ref.appProps,
    navigation = _ref.navigation,
    currentPath = _ref.currentPath,
    frontendStyles = _ref.frontendStyles,
    currentHeaderHeight = _ref.currentHeaderHeight,
    item = _ref.item,
    itemTranslation = _ref.itemTranslation,
    link = _ref.link,
    navWithLink = _ref.navWithLink,
    navNoLink = _ref.navNoLink,
    navigationItemHrefClass = _ref.navigationItemHrefClass,
    prefixLink = _ref.prefixLink,
    setMainNavHover = _ref.setMainNavHover,
    setHeaderRerenderer = _ref.setHeaderRerenderer;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    navigationState = _useState2[0],
    setNavigationState = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    showMenuItem = _useState4[0],
    setShowMenuItem = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    showSubmenuItem = _useState6[0],
    setShowSubmenuItem = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    subNavItemHover = _useState8[0],
    setSubNavItemHover = _useState8[1];
  var navRef = useRef(null);
  function menuItemOpener(openerProps) {
    setMainNavHover(openerProps.id);
    setSubNavItemHover(openerProps.id);
    navRef.current = openerProps;
    if (navigationState.length === 0) {
      setNavigationState(function (prevState) {
        return [].concat(_toConsumableArray(prevState), [openerProps]);
      });
    } else {
      if (navigationState.find(function (navItem) {
        return navItem.id === navRef.current.id || navItem.childrenIds.find(function (c) {
          return c === navRef.current.id;
        });
      })) {
        setNavigationState(function (prevState) {
          return [].concat(_toConsumableArray(prevState), [openerProps]);
        });
      }
    }
  }
  function menuItemCloser(closerProps) {
    setMainNavHover(null);
    setSubNavItemHover(null);
    if (navigationState.find(function (navItem) {
      return navItem.id === navRef.current.id;
    })) {
      setNavigationState(function (prevState) {
        return prevState.filter(function (item) {
          return item.depth < closerProps.depth;
        });
      });
    }
  }
  function recursivelyRenderChildren(item, navigationClass) {
    var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var itemVisibility = navigationState.find(function (navItem) {
      return navItem.id === item.id || navItem.children && navItem.children.find(function (c) {
        return c.id === item.id;
      });
    });
    var itemTranslation = item.translations.find(function (t) {
      return t.locale === appProps.currentLocale;
    });
    var currentNavigationLink = '/' + appProps.currentLocale + itemTranslation.link;
    return /*#__PURE__*/React.createElement(React.Fragment, null, itemVisibility && /*#__PURE__*/React.createElement("div", {
      className: "simple-menu ".concat(navigationClass === 'child-submenu' ? '' : navigationClass, " "),
      style: _objectSpread(_objectSpread(_objectSpread({
        top: '100%',
        color: currentPath === currentNavigationLink || subNavItemHover === item.id ? frontendStyles.headerNavigation.submenuItemColorHover : frontendStyles.headerNavigation.submenuItemColor,
        backgroundColor: currentPath === currentNavigationLink || subNavItemHover === item.id ? frontendStyles.headerNavigation.submenuItemBackgroundHover : frontendStyles.headerNavigation.submenuItemBackground
      }, navigationClass === 'submenu' ? HeaderNavigationStyles.submenu : {}), itemVisibility ? HeaderNavigationStyles.submenuOpen : {}), navigationClass === 'child-submenu' ? {} : HeaderNavigationStyles.menuWrapper)
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(navigationClass === 'child-submenu' ? 'child-submenu flex-box flex-column' : 'child-submenu-recursive')
    }, item.children.map(function (child, index) {
      var childTranslation = child.translations.find(function (t) {
        return t.locale === appProps.currentLocale;
      });
      var link = prefixLink(child, appProps);
      var currentChildNavigationLink = '/' + appProps.currentLocale + childTranslation.link;
      var linkStyles = {
        width: '100%',
        fontFamily: frontendStyles.h5styles.fontFamily,
        fontSize: frontendStyles.h5styles.fontSize,
        fontWeight: frontendStyles.h5styles.fontWeight,
        letterSpacing: frontendStyles.h5styles.letterSpacing,
        lineHeight: frontendStyles.h5styles.lineHeight,
        textTransform: frontendStyles.h5styles.textTransform,
        padding: 10,
        color: currentPath === currentChildNavigationLink || subNavItemHover === child.id ? frontendStyles.headerNavigation.submenuItemColorHover : frontendStyles.headerNavigation.submenuItemColor,
        backgroundColor: currentPath === currentChildNavigationLink || subNavItemHover === child.id ? frontendStyles.headerNavigation.submenuItemBackgroundHover : frontendStyles.headerNavigation.submenuItemBackground
      };
      var navWithLink = /*#__PURE__*/React.createElement("a", {
        className: navigationItemHrefClass(child),
        style: linkStyles,
        href: link,
        rel: "nofollow noindex noreferrer",
        target: child.openNewPage ? '_blank' : '_self',
        dangerouslySetInnerHTML: {
          __html: childTranslation.title
        }
      });
      var navNoLink = /*#__PURE__*/React.createElement("div", {
        className: "pointer ".concat(navigationItemHrefClass(child)),
        style: linkStyles,
        dangerouslySetInnerHTML: {
          __html: childTranslation.title
        }
      });
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        onMouseEnter: function onMouseEnter() {
          return menuItemOpener({
            id: child.id,
            depth: depth + 1,
            childrenIds: child.children.map(function (i) {
              return i.id;
            })
          });
        },
        onMouseLeave: function onMouseLeave() {
          return menuItemCloser({
            id: child.id,
            depth: depth + 1,
            childrenIds: child.children.map(function (i) {
              return i.id;
            })
          });
        },
        className: "flex-box content-start",
        style: _objectSpread(_objectSpread({
          position: 'relative'
        }, navigationClass === 'submenu' ? HeaderNavigationStyles.submenu : {}), itemVisibility ? HeaderNavigationStyles.submenuOpen : {})
      }, !child.requiresLogin ? /*#__PURE__*/React.createElement(React.Fragment, null, " ", link ? navWithLink : navNoLink, " ") : /*#__PURE__*/React.createElement(React.Fragment, null, appProps.currentUserEmail && /*#__PURE__*/React.createElement(React.Fragment, null, " ", link ? navWithLink : navNoLink, " ")), recursivelyRenderChildren(child, 'child-submenu', depth + 1));
    }))));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, item.children.length >= 0 && /*#__PURE__*/React.createElement(React.Fragment, null, !item.requiresLogin ? /*#__PURE__*/React.createElement("div", {
    style: HeaderNavigationStyles.navigationItem,
    className: "navigation-item flex-box items-center main-level simple-menu-nav",
    onMouseEnter: function onMouseEnter() {
      return menuItemOpener({
        id: item.id,
        depth: 0,
        childrenIds: item.children.map(function (i) {
          return i.id;
        })
      });
    },
    onMouseLeave: function onMouseLeave() {
      return menuItemCloser({
        id: item.id,
        depth: 0,
        childrenIds: item.children.map(function (i) {
          return i.id;
        })
      });
    }
  }, itemTranslation && /*#__PURE__*/React.createElement(React.Fragment, null, " ", link ? navWithLink : navNoLink, " "), recursivelyRenderChildren(item, 'submenu', 0)) : /*#__PURE__*/React.createElement(React.Fragment, null, appProps.currentUserEmail && /*#__PURE__*/React.createElement("div", {
    style: HeaderNavigationStyles.navigationItem,
    className: "navigation-item flex-box items-center main-level simple-menu-nav",
    onMouseEnter: function onMouseEnter() {
      return menuItemOpener({
        id: item.id,
        depth: 0,
        childrenIds: item.children.map(function (i) {
          return i.id;
        })
      });
    },
    onMouseLeave: function onMouseLeave() {
      return menuItemCloser({
        id: item.id,
        depth: 0,
        childrenIds: item.children.map(function (i) {
          return i.id;
        })
      });
    }
  }, itemTranslation && /*#__PURE__*/React.createElement(React.Fragment, null, " ", link ? navWithLink : navNoLink, " "), recursivelyRenderChildren(item, 'submenu', 0)))));
}